<template>
<div class="chapter">
<div class="inner_page">
<p class="head">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/preface">Preface and Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter1">The Lake Declares War</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">Rène Hypolite Pepin La Force: Master Mariner, Naval Commander and Canadian Patriot</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">Captain Van Cleve: Businessman, Artist, Author and Mariner</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">Shipwrecks during the Age of Sail</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">Deadly November</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">Larger-Than-Life Lake Mariners</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">The Lake’s Loneliest Island</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">The Seaway System: Boon or Bungle?</span></p>
<p class="toc1"><span href="#/source" title="Link target outside of Sample">Sources and Further Reading</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e041dfda